class FindifyTheme {
  constructor(){this.bindSearch();this.bindQuantity();this.bindProductGallery();this.bindVariants();this.bindCollectionCarousels();this.bindShopTheLook();}
  bindSearch(){document.querySelectorAll('[data-search-toggle]').forEach(btn=>{btn.addEventListener('click',()=>{const panel=document.querySelector('[data-search-panel]');if(!panel)return;panel.classList.toggle('is-open');if(panel.classList.contains('is-open'))setTimeout(()=>panel.querySelector('input[type="search"]')?.focus(),50);});});}
  bindQuantity(){document.querySelectorAll('[data-quantity]').forEach(wrap=>{const input=wrap.querySelector('input');wrap.querySelectorAll('button').forEach(btn=>btn.addEventListener('click',()=>{const step=parseInt(btn.dataset.step,10)||0;const next=Math.max(parseInt(input.min||'1',10),parseInt(input.value||'1',10)+step);input.value=next;}));});}

  setActiveProductMedia(root,mediaId,{behavior='smooth',scroll=true}={}){
    if(!root||mediaId===null||mediaId===undefined)return;
    const gallery=root.querySelector('[data-product-gallery]');
    const viewport=gallery?.querySelector('[data-gallery-viewport]');
    if(!gallery||!viewport)return;
    const targetId=String(mediaId);
    const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
    const slide=slides.find(item=>String(item.dataset.mediaId)===targetId);
    if(!slide)return;

    slides.forEach(item=>{
      const active=item===slide;
      item.classList.toggle('is-active',active);
      item.setAttribute('aria-hidden',active?'false':'true');
      if(!active){
        item.querySelectorAll('video').forEach(video=>{try{video.pause();}catch(e){}});
      }
    });
    thumbs.forEach(thumb=>{
      const active=String(thumb.dataset.mediaId)===targetId;
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-current',active?'true':'false');
      if(active)thumb.scrollIntoView?.({behavior:behavior==='smooth'?'smooth':'auto',block:'nearest',inline:'nearest'});
    });

    if(scroll){
      const left=slide.offsetLeft;
      if(typeof viewport.scrollTo==='function')viewport.scrollTo({left,behavior});
      else viewport.scrollLeft=left;
    }
    gallery.dataset.activeMediaId=targetId;
  }

  bindProductGallery(){
    document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
      if(gallery.dataset.galleryBound==='true')return;
      gallery.dataset.galleryBound='true';
      const root=gallery.closest('[data-product-root]');
      const viewport=gallery.querySelector('[data-gallery-viewport]');
      const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
      const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
      if(!root||!viewport||!slides.length)return;

      thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{
        this.setActiveProductMedia(root,thumb.dataset.mediaId,{behavior:'smooth',scroll:true});
      }));

      let raf=0;
      const syncFromScroll=()=>{
        cancelAnimationFrame(raf);
        raf=requestAnimationFrame(()=>{
          const center=viewport.scrollLeft+viewport.clientWidth/2;
          let nearest=slides[0],distance=Infinity;
          slides.forEach(slide=>{
            const slideCenter=slide.offsetLeft+slide.offsetWidth/2;
            const d=Math.abs(slideCenter-center);
            if(d<distance){distance=d;nearest=slide;}
          });
          if(nearest?.dataset.mediaId)this.setActiveProductMedia(root,nearest.dataset.mediaId,{behavior:'auto',scroll:false});
        });
      };
      viewport.addEventListener('scroll',syncFromScroll,{passive:true});
    });
  }

  bindVariants(){
    document.querySelectorAll('[data-product-root]').forEach(root=>{
      if(root.dataset.variantBound==='true')return;
      root.dataset.variantBound='true';
      const dataEl=root.querySelector('[data-variants-json]');if(!dataEl)return;
      let variants=[];try{variants=JSON.parse(dataEl.textContent);}catch(e){return;}
      const selects=[...root.querySelectorAll('[data-option-select]')];
      const idInput=root.querySelector('[name="id"]');
      const add=root.querySelector('[data-add-to-cart]');
      const price=root.querySelector('[data-current-price]');
      const compare=root.querySelector('[data-compare-price]');
      const currency=root.dataset.currency||'TRY';
      const money=cents=>{try{return new Intl.NumberFormat(document.documentElement.lang||'tr-TR',{style:'currency',currency}).format(cents/100);}catch(e){return(cents/100).toFixed(2)+' '+currency;}};
      const update=({updateUrl=true,behavior='smooth'}={})=>{
        const opts=selects.map(s=>s.value);
        const variant=variants.find(v=>v.options.every((o,i)=>o===opts[i]));
        if(!variant)return;
        if(idInput)idInput.value=variant.id;
        if(add){add.disabled=!variant.available;add.textContent=variant.available?(add.dataset.availableLabel||'Sepete ekle'):(add.dataset.soldoutLabel||'Tükendi');}
        if(price)price.textContent=money(variant.price);
        if(compare){if(variant.compare_at_price&&variant.compare_at_price>variant.price){compare.textContent=money(variant.compare_at_price);compare.hidden=false;}else compare.hidden=true;}
        const featuredMediaId=variant.featured_media?.id||variant.featured_media_id;if(featuredMediaId)this.setActiveProductMedia(root,featuredMediaId,{behavior,scroll:true});
        if(updateUrl){const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url);}
        root.dispatchEvent(new CustomEvent('findify:variant-change',{bubbles:true,detail:{variant}}));
      };
      selects.forEach(s=>s.addEventListener('change',()=>update({updateUrl:true,behavior:'smooth'})));
      update({updateUrl:false,behavior:'auto'});
    });
  }

  bindCollectionCarousels(root=document){
    root.querySelectorAll('[data-collection-carousel]').forEach(section=>{
      if(section.dataset.collectionCarouselBound==='true')return;
      section.dataset.collectionCarouselBound='true';

      const viewport=section.querySelector('[data-collection-viewport]');
      const cards=[...section.querySelectorAll('[data-collection-card]')];
      const prev=section.querySelector('[data-collection-prev]');
      const next=section.querySelector('[data-collection-next]');
      const dotsWrap=section.querySelector('[data-collection-dots]');
      if(!viewport||!cards.length||!dotsWrap)return;

      let pageSize=1;
      let pageCount=1;
      let activePage=0;
      let resizeTimer=0;
      let scrollFrame=0;

      const getGap=()=>{
        const track=viewport.querySelector('.findify-collection-carousel__track');
        const styles=track?getComputedStyle(track):null;
        return parseFloat(styles?.columnGap||styles?.gap||'0')||0;
      };
      const getStep=()=>cards[0].getBoundingClientRect().width+getGap();

      const calculate=()=>{
        const step=getStep();
        pageSize=Math.max(1,Math.floor((viewport.clientWidth+getGap())/step));
        pageCount=Math.max(1,Math.ceil(cards.length/pageSize));
        activePage=Math.min(activePage,pageCount-1);
      };

      const setControls=()=>{
        prev && (prev.disabled=viewport.scrollLeft<=4);
        if(next){
          const max=Math.max(0,viewport.scrollWidth-viewport.clientWidth);
          next.disabled=viewport.scrollLeft>=max-4;
        }
        [...dotsWrap.children].forEach((dot,index)=>{
          const active=index===activePage;
          dot.classList.toggle('is-active',active);
          dot.setAttribute('aria-current',active?'true':'false');
        });
      };

      const renderDots=()=>{
        calculate();
        dotsWrap.innerHTML='';
        if(pageCount<=1){
          dotsWrap.hidden=true;
          if(prev)prev.hidden=true;
          if(next)next.hidden=true;
          return;
        }
        dotsWrap.hidden=false;
        if(prev)prev.hidden=false;
        if(next)next.hidden=false;
        for(let i=0;i<pageCount;i++){
          const dot=document.createElement('button');
          dot.type='button';
          dot.className='findify-collection-carousel__dot';
          dot.setAttribute('aria-label',`${i+1}. koleksiyon grubu`);
          dot.addEventListener('click',()=>{
            const left=i*pageSize*getStep();
            viewport.scrollTo({left,behavior:'smooth'});
          });
          dotsWrap.appendChild(dot);
        }
        setControls();
      };

      const updateFromScroll=()=>{
        cancelAnimationFrame(scrollFrame);
        scrollFrame=requestAnimationFrame(()=>{
          const step=getStep()*pageSize;
          activePage=Math.max(0,Math.min(pageCount-1,Math.round(viewport.scrollLeft/Math.max(step,1))));
          setControls();
        });
      };

      const move=direction=>{
        const amount=pageSize*getStep()*direction;
        viewport.scrollBy({left:amount,behavior:'smooth'});
      };

      prev?.addEventListener('click',()=>move(-1));
      next?.addEventListener('click',()=>move(1));
      viewport.addEventListener('scroll',updateFromScroll,{passive:true});
      viewport.addEventListener('keydown',e=>{
        if(e.key==='ArrowRight'){e.preventDefault();move(1);}
        if(e.key==='ArrowLeft'){e.preventDefault();move(-1);}
      });
      window.addEventListener('resize',()=>{
        clearTimeout(resizeTimer);
        resizeTimer=setTimeout(renderDots,120);
      });

      renderDots();
    });
  }

  bindShopTheLook(root=document){
    root.querySelectorAll('[data-shop-look]').forEach(section=>{
      if(section.dataset.lookBound==='true')return;
      section.dataset.lookBound='true';
      const hotspots=[...section.querySelectorAll('[data-look-hotspot]')];
      const cards=[...section.querySelectorAll('[data-look-card]')];
      const rails=[...section.querySelectorAll('[data-look-open]')];
      const tabs=[...section.querySelectorAll('[data-look-tab]')];
      const panels=[...section.querySelectorAll('[data-look-panel]')];

      const closeAll=()=>{cards.forEach(c=>{c.hidden=true;c.removeAttribute('data-side');c.style.left='';c.style.top='';c.style.right='';c.style.bottom='';});hotspots.forEach(h=>{h.classList.remove('is-active');h.setAttribute('aria-expanded','false');});rails.forEach(r=>r.classList.remove('is-active'));};
      const positionCard=(card,hot)=>{
        const scene=hot.closest('[data-look-scene]');if(!scene||!card||window.matchMedia('(max-width: 680px)').matches)return;
        const sr=scene.getBoundingClientRect(),hr=hot.getBoundingClientRect();
        const x=hr.left-sr.left+hr.width/2,y=hr.top-sr.top+hr.height/2;
        const cw=card.offsetWidth,ch=card.offsetHeight,gap=18,pad=14;
        let side='right',left=x+gap;
        if(left+cw>scene.clientWidth-pad){side='left';left=x-gap-cw;}
        left=Math.max(pad,Math.min(left,scene.clientWidth-cw-pad));
        let top=y-ch/2;top=Math.max(pad,Math.min(top,scene.clientHeight-ch-pad));
        const pointerY=Math.max(24,Math.min(y-top,ch-24));
        card.style.left=`${left}px`;card.style.top=`${top}px`;card.style.right='auto';card.style.bottom='auto';card.style.setProperty('--pointer-y',`${pointerY}px`);card.dataset.side=side;
      };
      const open=id=>{
        const card=section.querySelector(`[data-look-card="${id}"]`),hot=section.querySelector(`[data-look-hotspot="${id}"]`);if(!card||!hot)return;
        const already=!card.hidden;closeAll();if(already)return;
        card.hidden=false;hot.classList.add('is-active');hot.setAttribute('aria-expanded','true');section.querySelector(`[data-look-open="${id}"]`)?.classList.add('is-active');
        requestAnimationFrame(()=>positionCard(card,hot));
      };
      const activateScene=id=>{
        closeAll();
        tabs.forEach(t=>{const active=t.dataset.lookTab===id;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',active?'true':'false');});
        panels.forEach(p=>{p.hidden=p.dataset.lookPanel!==id;});
      };
      hotspots.forEach(h=>h.addEventListener('click',()=>open(h.dataset.lookHotspot)));
      rails.forEach(r=>r.addEventListener('click',()=>open(r.dataset.lookOpen)));
      tabs.forEach(t=>t.addEventListener('click',()=>activateScene(t.dataset.lookTab)));
      section.querySelectorAll('[data-look-close]').forEach(b=>b.addEventListener('click',closeAll));
      section.addEventListener('keydown',e=>{if(e.key==='Escape')closeAll();});
      section.querySelectorAll('[data-look-variant]').forEach(select=>select.addEventListener('change',()=>{const card=select.closest('[data-look-card]'),price=card?.querySelector('[data-look-price]'),option=select.options[select.selectedIndex];if(price&&option?.dataset.price)price.textContent=option.dataset.price;}));
      section.querySelectorAll('[data-look-form]').forEach(form=>form.addEventListener('submit',async e=>{
        if(!window.fetch)return;e.preventDefault();const btn=form.querySelector('[data-look-add]'),status=form.querySelector('[data-look-status]'),original=btn?.textContent;
        try{if(btn){btn.disabled=true;btn.textContent='Ekleniyor…';}if(status)status.textContent='';const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)});if(!response.ok)throw new Error('add_failed');const cart=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());let badge=document.querySelector('.header__actions .cart-count');if(!badge){const cartLink=document.querySelector('.header__actions a[href*="/cart"]');if(cartLink){badge=document.createElement('span');badge.className='cart-count';cartLink.appendChild(badge);}}if(badge)badge.textContent=cart.item_count;if(status)status.textContent='Sepete eklendi.';if(btn)btn.textContent='Sepete eklendi ✓';setTimeout(()=>{if(btn){btn.disabled=false;btn.textContent=original||'Sepete ekle';}},1400);}catch(err){if(status)status.textContent='Ürün eklenemedi. Lütfen tekrar deneyin.';if(btn){btn.disabled=false;btn.textContent=original||'Sepete ekle';}}
      }));
      window.addEventListener('resize',()=>{const active=section.querySelector('[data-look-card]:not([hidden])');if(active){const id=active.dataset.lookCard,hot=section.querySelector(`[data-look-hotspot="${id}"]`);if(hot)requestAnimationFrame(()=>positionCard(active,hot));}});
      section._findifyActivateScene=activateScene;
    });
  }
}
document.addEventListener('DOMContentLoaded',()=>new FindifyTheme());
document.addEventListener('shopify:section:load',e=>{const theme=new FindifyTheme();theme.bindCollectionCarousels(e.target);theme.bindShopTheLook(e.target);});
document.addEventListener('shopify:block:select',e=>{const panel=e.target.closest?.('[data-scene-block-id]');if(!panel)return;const section=panel.closest('[data-shop-look]');section?._findifyActivateScene?.(panel.dataset.sceneBlockId);});
